import { pushEvent } from 'src/client/data-layer';

export type TrackInternalNavigationClickData = {
  scope: InternalNavigationScope;
  nextPage: string;
  index?: number;
};

export const trackInternalNavigationClick = (
  data: TrackInternalNavigationClickData
) => {
  pushEvent('internal_navigation_click', {
    scope: data.scope,
    current_page: window.location.pathname + window.location.search,
    next_page: data.nextPage,
    index: typeof data.index === 'number' ? data.index + 1 : 'no index',
  });
};

export enum InternalNavigationScope {
  ABOUT_REVIEWS = 'About reviews',
  ARTICLE_CONTENT_CARD = 'Article - content card',
  ARTICLE_READ_MORE = 'Article - read more',
  ARTICLE_SHOW_ALL = 'Article - show all',
  ARTICLE_PRODUCT_CARD = 'Article - product card',
  AUTHORIZED_DEALER = 'Authorized dealer',
  BRAND_CARD = 'Brand - card',
  BRAND_CATEGORY_CARD = 'Brand - category card',
  BRAND_CATEGORY_TREE = 'Brand - category tree',
  BRAND_PRODUCT_CARD = 'Brand - product card',
  BREADCRUMB = 'Breadcrumb',
  CALL_TO_ACTION = 'Call to action',
  CAMPAIGN_GO_TO = 'Campaign - go to',
  CAMPAIGN_HEADER = 'Campaign - header',
  CAMPAIGN_PRODUCT_CARD = 'Campaign - product card',
  CAMPAIGN_SHOW_ALL = 'Campaign - show all',
  CATEGORY_CARD = 'Category - card',
  CATEGORY_INDEX_LINK = 'Category index - link',
  CATEGORY_LIST_SUB_LVL = 'Category list - sub level',
  CATEGORY_LIST_TOP_LVL = 'Category list - top level',
  COMPACT_LIST_LAYOUT_PRODUCT_CARD = 'Compact list layout - product card',
  COMPARE_PRODUCTS_PRODUCT_HEADER = 'Compare products - product header',
  COMPARE_PRODUCTS_PRODUCT_IMAGE = 'Compare products - product image',
  EXPERT_ADVISE_SHOW_ALL = 'Expert advise - show all',
  EXPERT_ALL_CATEGORIES = 'Expert - all categories',
  EXPERT_CATEGORIES = 'Expert - categories',
  EXPERT_CATEGORY_AREA = 'Expert - category area',
  EXPERT_PROFILE_GO_TO = 'Expert profile - go to',
  EXPERT_INDEPENDENT_GUARANTEE = 'Expert - independent guarantee',
  EXPERT_LIST_PROFILE_GO_TO = 'Expert list profile - go to',
  EXPERT_LIST_EXPERT_PAGE_GO_TO = 'Expert list expert-page - go to',
  EXPERT_ALSO_IN_CATEGORIES = 'Expert - also in categories',
  EXPERT_PAGE_GO_TO = 'Expert-page - go to',
  EXPERT_PROMO = 'Expert - promo',
  EXPERT_RECOMMEND_PRODUCTS = 'Expert - recommend products',
  EXPERT_SEARCH_RESULT_CATEGORY_GO_TO = 'Expert search result - category go to',
  EXPERT_SEARCH_RESULT_PRODUCT_TEST_GO_TO = 'Expert search result - product-test go to',
  EXPERT_SEARCH_RESULT_TOPLIST_GO_TO = 'Expert search result - toplist go to',
  EXPERT_SHOW_ALL_IN_CATEGORY = 'Expert - show all in category',
  EXPERT_TOP_LIST = 'Expert - top list',
  FALLBACK_RECOMMENDATIONS_PRODUCT_CARD = 'Fallback recommendations - product card',
  FALLBACK_RECOMMENDATIONS_HEADER = 'Fallback recommendations - header',
  FEATURED_CATEGORY_ARTICLE = 'Featured category article',
  FEATURED_PRODUCTS_PRODUCTS_CARD = 'Featured products - product card',
  FEATURED_PRODUCTS_HEADER = 'Featured products - header',
  FOOTER_INFO_PAGES = 'Footer - info pages',
  FORUM_TOPIC = 'FORUM - topic',
  FORUM_GO_TO = 'FORUM - go to',
  GRID_LAYOUT_PRODUCT_CARD = 'Grid layout - product card',
  GUIDE_EXPERT_TOPLIST = 'Guide - expert toplist',
  GUIDE_PAGE_GO_TO = 'Guide-page - go to',
  LIST_LAYOUT_PRODUCT_CARD = 'List layout - product card',
  MY_PROFILE_SETTINGS_USER_DATA = 'My profile - settings user data',
  MY_PROFILE_USER_REVIEW_CARD = 'My profile - user review card',
  NAVIGATION_CAROUSEL = 'Navigation carousel',
  NEWSLETTER_EMAIL_PRIVACY = 'Newsletter - email privacy',
  NEW_PRODUCT_RELEASES_PRODUCT_CARD = 'New Product releases - product card',
  NEW_PRODUCT_RELEASES_HEADER = 'New Product releases - header',
  OTHER_PRODUCTS_PRODUCT_CARD = 'Other popular products - product card',
  OTHER_VISITED_PRODUCTS_PRODUCT_CARD = 'Other visited - product card',
  PERSONALIZED_RECOMMENDATIONS_PRODUCT_CARD = 'Personalized recommendations - product card',
  PERSONALIZED_RECOMMENDATIONS_HEADER = 'Personalized recommendations - header',
  PRODUCT_INFORMATION = 'Product information',
  POPULAR_FACETS_HEADER = 'Popular facets - header',
  POPULAR_FACETS_PRODUCT_CARD = 'Popular facets - product card',
  POPULAR_PRODUCTS_HEADER = 'Popular products - header',
  POPULAR_PRODUCTS_SHOW_ALL = 'Popular products - show all',
  POPULAR_PRODUCTS_PRODUCT_CARD = 'Popular products - product card',
  POPULAR_PRODUCTS_PRODUCT_CARD_CATEGORY_LINK = 'Popular products - product card category link',
  PRODUCT_COLLECTION_SITEMAP_LINK = 'Product-collection sitemap - link',
  PRODUCT_TEST_PAGE_GO_TO = 'Product-test-page - go to',
  PRODUCT_TEST_SIDEBAR_FIND_BEST_PRICE = 'Product-test - sidebar find best price',
  PRODUCT_TEST_SIDEBAR_PRODUCT_CARD = 'Product-test - sidebar product card',
  PRODUCT_TEST_SIDEBAR_RANK_IN_CATEGORY = 'Product-test - sidebar rank in category',
  RECENT_SEARCHES_HERO = 'Recent-searches - hero',
  RECENTLY_VISITED_PRODUCT_CARD = 'Recently visited - product card',
  RECENTLY_VISITED_PRODUCT_COLLECTION_CARD = 'Recently visited - product collection card',
  REVIEW_READ_ALL = 'Review - read all',
  REVIEW_USER_CARD = 'Review - user card',
  RATE_SHOP_GO_TO = 'Rate shop - go to',
  RELATED_ARTICLE = 'Related article',
  RELATED_SEARCHES_SHOW_MORE = 'Related searches - show more',
  RELATED_SEARCHES_WORD = 'Related searches - word',
  SECONDARY_NAVIGATION = 'Secondary navigation',
  SPONSORED_PRODUCT = 'Sponsored product',
  STORE_AWARD_CARD = 'Store - award card',
  STORE_CARD = 'Store - card',
  STORE_GO_TO = 'Store - go to',
  STORE_REVIEW = 'Store - review',
  TABLE_LAYOUT_PRODUCT_CARD = 'Table layout - product card',
  TOPLIST_COMPARE_PRODUCTS = 'Toplist - compare products',
  TOPLIST_MORE_FROM_EXPERT = 'Toplist - More from expert',
  TOPLIST_MORE_REVIEWS_FOR_CATEGORY = 'Toplist - More reviews for category',
  TOPLIST_PAGE_GO_TO = 'Toplist-page - go to',
  TOPLIST_PAGE_HEADLINE_GO_TO = 'Toplist-page headline - go to',
  TOPLIST_PRODUCT_IN_TOPLIST = 'Toplist - Product in toplist',
  TOPLIST_PRODUCT_TEST = 'Toplist - product test',
  TRENDING_PRODUCTS_HEADER = 'Trending products - header',
  TRENDING_PRODUCTS_PRODUCT_CARD = 'Trending products - product card',
}
